import {AEntity} from "./abstract/AEntity";
import {type ITag, Tag} from "./Tag";

export interface IAgent {
    nni: string
    telMob: string
    telFix: string
    ageDesc: string
    fct?: string | null
    sitLib: string
    fsdum: string
    tags: ITag[]
    /** Prénom persisté par l’API Mon Orga. */
    firstName?: string | null
    /** Nom persisté par l’API Mon Orga. */
    lastName?: string | null
    /** E-mail professionnel persisté par l’API Mon Orga. */
    email?: string | null
    avatarDisplayMode?: 'teams' | 'initials' | 'avatar' | null
    avatarConfig?: Record<string, unknown> | null
}

export class Agent extends AEntity {
    nni: string
    telMob: string
    telFix: string
    ageDesc: string
    fct?: string | null
    sitLib: string
    fsdum: string
    tags: Tag[]
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    avatarDisplayMode?: 'teams' | 'initials' | 'avatar' | null
    avatarConfig?: Record<string, unknown> | null

    constructor(agent: IAgent) {
        super();
        this.nni = agent.nni
        this.telMob = agent.telMob
        this.telFix = agent.telFix
        this.ageDesc = agent.ageDesc
        this.fct = agent.fct ?? null
        this.sitLib = agent.sitLib
        this.fsdum = agent.fsdum
        this.tags = agent.tags.map(tag => new Tag(tag))
        this.firstName = agent.firstName
        this.lastName = agent.lastName
        this.email = agent.email
        this.avatarDisplayMode = agent.avatarDisplayMode ?? null
        this.avatarConfig = agent.avatarConfig ?? null
    }

    override getId(): string {
        return `${this.nni}`;
    }

    override toJSON(): IAgent {
        return {
            nni: this.nni,
            telMob: this.telMob,
            telFix: this.telFix,
            ageDesc: this.ageDesc,
            fct: this.fct ?? null,
            sitLib: this.sitLib,
            fsdum: this.fsdum,
            tags: this.tags.map(tag => tag.toJSON()),
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            avatarDisplayMode: this.avatarDisplayMode ?? null,
            avatarConfig: this.avatarConfig ?? null,
        }
    }
}
